/**
 * @generated SignedSource<<6b043ee851946f7aeaced24ca32ea269>>
 * @relayHash d5c85b9b9fae463c8e45290daac70048
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3178f46ab936b2e7115dee54438829d2af19a1a8f85b028faa20238b6c3a114c

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type onboarding_setShowRedactionChangeBoardingOnIssueViewAsViewerMutation$variables = {
  cloudId: string;
  show: boolean;
};
export type onboarding_setShowRedactionChangeBoardingOnIssueViewAsViewerMutation$data = {
  readonly jira: {
    readonly userPreferences: {
      readonly setShowRedactionChangeBoardingOnIssueViewAsViewer: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type onboarding_setShowRedactionChangeBoardingOnIssueViewAsViewerMutation = {
  response: onboarding_setShowRedactionChangeBoardingOnIssueViewAsViewerMutation$data;
  variables: onboarding_setShowRedactionChangeBoardingOnIssueViewAsViewerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "show"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "concreteType": "JiraUserPreferencesMutation",
        "kind": "LinkedField",
        "name": "userPreferences",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "show",
                "variableName": "show"
              }
            ],
            "kind": "ScalarField",
            "name": "setShowRedactionChangeBoardingOnIssueViewAsViewer"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "onboarding_setShowRedactionChangeBoardingOnIssueViewAsViewerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "onboarding_setShowRedactionChangeBoardingOnIssueViewAsViewerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "3178f46ab936b2e7115dee54438829d2af19a1a8f85b028faa20238b6c3a114c",
    "metadata": {},
    "name": "onboarding_setShowRedactionChangeBoardingOnIssueViewAsViewerMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "202c2d02b05a4f4679dac304087b8689";

export default node;
